<template>
    <div class="goods-form">
        <veui-form ref="culeFormMember" :data="formData">
            <veui-field
                name="product"
                label="选择产品"
                class="veui-field-required"
            >
                <div
                    v-for="item in curGoodsInfo"
                    :key="item.type"
                    class="goods-box"
                    @click="handleGoodsClick(item)"
                >
                    <goodsCard
                        :discount-txt="
                            item.discount && +item.discount < 10
                                ? item.discount_txt
                                : ''
                        "
                        :origin-price="item.origin_price"
                        :name="goodsList.name"
                        :goods-type="item.type"
                        :show-price="item.show_price"
                        :is-active="item.type === formData.vip_duration"
                    />
                </div>
            </veui-field>
            <veui-field
                name="num" label="购买数量"
                :rules="numRule"
            >
                <veui-number-input
                    v-model="formData.num"
                    ui="m"
                    :max="100"
                    :min="1"
                    placeholder="请输入不超过100个律临会员数"
                    style="width: 300px"
                />
            </veui-field>
            <veui-field
                name="isAgree"
                label=""
                :rules="[
                    {
                        name: 'required',
                        trigger: 'change',
                        value: true,
                        message: '请阅读并勾选协议',
                    },
                ]"
            >
                <veui-checkbox v-model="formData.isAgree" :false-value="null">
                    我已阅读并同意<span
                        class="goods-form-rule"
                        @click.stop="openRule"
                    >《{{ agreementInfo.name }}》</span>
                </veui-checkbox>
            </veui-field>
        </veui-form>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 律临v卡购买
 * @author
 */

import {Form, Field, Checkbox, NumberInput} from 'veui';
import isBoolean from 'lodash/isBoolean';
import bendSDK from '@baidu/bend-plugin-sdk';
import 'veui-theme-dls-icons/exclamation-circle';
import 'veui-theme-dls-icons/building';
import 'veui-theme-dls-icons/tag';
import goodsCard from './goodsCard.vue';

const url = {
    vipbuyprice: 'law:/themis/law/commodity/vipbuyprice',
    buycode: 'law:/themis/law/commodity/vipbuycode',
    clueOrderlist: 'law:/themis/law/commodity/orderlist'
};
const tipMap = {
    building: 'https://lvlin-base.cdn.bcebos.com/fe-saas/common/city_level.pdf',
    tag: 'https://law-smartapp.cdn.bcebos.com/pdf/tag_list.pdf'
};
export default {
    name: 'goodsForm',
    props: {
        goodsList: {
            type: Object,
            default: () => {}
        },
        goodsForm: {
            type: Object,
            default: () => {}
        },
        goodsOrder: {
            type: Object,
            default: () => {}
        },
        agreementInfo: {
            type: Object,
            default: () => {}
        },
        goodsInfo: {
            type: Object,
            default: () => {}
        },
        channel: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            numRule: [
                {
                    name: 'required',
                    value: true,
                    message: '请输入V卡数量',
                    triggers: 'change'
                }
            ],
            formData: {
                city_level: 'FIRST_CITY',
                vip_duration: 'full_year'
            },
            validators: [
                {
                    fields: ['num'],
                    validate(value) {
                        this.data.hiddenTip = '';
                        return new Promise(resolve => {
                            let res;
                            if (value > 50) {
                                res = {
                                    num: '请输入不超过100个律临V卡数'
                                };
                            }
                            return resolve(res);
                        });
                    },
                    triggers: ['change']
                }
            ]
        };
    },
    computed: {
        curGoodsInfo() {
            const goods = this.goodsInfo?.vcard_vip || {};
            const {discount, discount_txt, expire} = goods;
            let goodsList = [];
            let goodsKey = Object.keys(expire || {});
            goodsKey.forEach(item => {
                const element = {
                    type: item,
                    discount,
                    discount_txt,
                    origin_price: expire[item],
                    show_price: (expire[item] * discount) / 10
                };
                goodsList.push(element);
            });
            return goodsList || [];
        }
    },
    components: {
        'veui-form': Form,
        'veui-field': Field,
        'veui-checkbox': Checkbox,
        'veui-number-input': NumberInput,
        goodsCard
    },
    created() {},
    mounted() {
        if (this.$route.query.orderId && this.$route.query.goodsId === '6') {
            this.getOrderInfo(this.$route.query.orderId);
        }
    },
    methods: {
        handleGoodsClick(item) {
            this.formData.vip_duration = item.type;
        },
        sumbitForm() {
            this.$refs.culeFormMember.validate().then(flag => {
                if (isBoolean(flag) && flag) {
                    if (+this.channel === 1) {
                        this.$emit('handleCapitalPoolOrder');
                        return;
                    }
                    this.postData();
                }
                else {
                    const toast = {
                        content: '请完成必填选项',
                        duration: 3
                    };
                    this.$Message.info(toast);
                    this.$emit('nextStep', false);
                }
            });
        },
        postData() {
            const postParams = {
                num: this.formData.num, // 购买数量
                agreement_ids: this.agreementInfo.id,
                vip_duration: this.formData.vip_duration,
                code_type: 1
            };
            this.$http
                .post(url.buycode, {
                    ...postParams,
                    params: JSON.stringify(postParams)
                })
                .then(resp => {
                    const data = this.$normalizeResponseData(resp);
                    if (data) {
                        const {
                            num,
                            discount_amount,
                            discount,
                            should_pay_amount
                        } = data.product_info;
                        const order = {
                            name: '律临V卡',
                            range:
                                this.formData.vip_duration === 'full_year'
                                    ? '一年卡'
                                    : '半年卡',
                            numTxt: `${num}个`,
                            discountAmountTxt:
                                discount_amount > 0
                                    ? `-￥${discount_amount / 100}(${
                                        (discount * 1000) / 100
                                    }折优惠)`
                                    : discount_amount,
                            pay_url: data.order_info.order_info_url,
                            pay_amount: should_pay_amount || 0,
                            num: num || 0
                        };
                        this.$emit('setGoodsFn', 'goodsOrder', order);
                        this.$emit('nextStep', true);
                    }
                    else {
                        this.$emit('nextStep', false);
                    }
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.$emit('nextStep', false);
                });
        },
        openRule() {
            window.open(this.agreementInfo.url);
        },
        openTip(name) {
            window.open(tipMap[name]);
        },
        getOrderInfo(orderId) {
            const params = {
                order_status: '',
                begin_time: '',
                end_time: '',
                pn: 1,
                rn: 10,
                tp_oid: orderId
            };
            this.$http
                .get(url.clueOrderlist, {
                    params
                })
                .then(resp => {
                    const data = resp?.data?.data || {};
                    if (data && data.data && data.data.list.length) {
                        const {product_num = null} = data.data.list[0];
                        this.$nextTick(() => {
                            this.formData = {
                                ...this.formData,
                                num: product_num
                            };
                        });
                    }
                })
                .catch(err => this.$normalizeResponseError(err));
        }
    }
};
</script>

<style scoped lang="stylus">
.goods-form {
    margin-bottom: -24px;
    .goods-form-num {
        display: block;
        &-tip {
            height: 32px;
            color: #282C33;
            line-height: 32px;
        }
        &-input {
            margin-top: 8px;
        }
        &-text {
            margin-top: 8px;
            color: #848B99;
        }
        &-icon {
            font-size: 14px;
            width: 14px;
            height: 14px;
            color: #848B99;
        }
    }
    /deep/ .veui-field-label {
        width: calc(5em + 6px);
    }
    .veui-field-no-label {
        margin-left: 12px;
    }
    .goods-form-rule {
        color: #0052CC;
    }
    /deep/ .clue-city-radio>.veui-radio-box {
        display: none;
    }
    .goods-box {
        &:not(:first-child) {
            margin-left: 16px;
        }
    }
    .form-icon {
        cursor: pointer;
        color: #282C33;
        margin-left: 12px;
    }
}
</style>
